import { render, staticRenderFns } from "./BaseFlex.vue?vue&type=template&id=9a37164e"
import script from "./BaseFlex.vue?vue&type=script&lang=js"
export * from "./BaseFlex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports